<template>
<div id="share-tab" class="container">
    <div class="row head m-t-6">
        <div class="col-xs-6">
            <b>{{ selectedEntities.length }}</b> selected
        </div>

        <div class="col-xs-6 text-right">
            <span @click="shareMobile()" class="button button-center" v-show="shareLink">
                <i class="iconify icon:ion:share-social" v-if="isAndroid"></i>
                <i class="iconify icon:ion:share-sharp" v-if="!isAndroid"></i>
            </span>

            <span @click="showFilters = true" class="button button-center">
                <i class="iconify icon:mdi:filter"></i>
            </span>
        </div>

        <div class="col-xs-12 m-t-6">
            <input type="text" class="search" placeholder="Search label, radios or publisers" @keyup="searchContacts">
            <i class="iconify icon:mdi:account-search"></i>
        </div>
    </div>

    <div class="row content" v-show="!showSuccess" :class="{'small': !hasResults}">
        <div class="col-xs-12 results" v-if="hasResults">
            <div v-for="user in results" @click="toggleSelect(user)" class="col-xs-12 user button button-center button-white" :class="{ 'selected': isSelected(user), 'favorite': user.is_contact }">
                <div class="thumb" :style="profileImage(user)"></div>
                <div class="info">
                    <p>{{ user.name }}</p>
                    <span>{{ user.type }}</span>
                </div>
            </div>

            <div v-show="!fetchedAllUsers" class="col-xs-12 text-center">
                <loader size="128px"></loader>
            </div>

            <div v-show="fetchedAllUsers" class="col-xs-12 text-center">
                <br><i class="iconify icon:uil:grip-horizontal-line text-disabled" data-height="24"></i>
            </div>            
        </div>

        <div v-if="!hasResults && !loading" class="col-xs-12 text-center no-result">
            <h4>No results found!</h4>
            <p>Your search or filtering didn’t provide any results. Try to select all user types, genres and/or more countries.</p>
        </div>

        <div class="col-xs-12 text-center" v-show="!hasResults && loading">
            <loader color="ripple" size="150px"></loader>
            <!-- <p style="margin-top: -30px; color: #ccc; font-weight: 700;">FETCHING USERS</p> -->
        </div>
    </div>

    <div class="row content" v-show="showSuccess">
        <div class="success-message text-center col-xs-12">
            <h4>SONG HAS BEEN SHARED!</h4>
            <p>The song has been shared succesfully to the selected entities. Please don’t abuse this feature, as your account may be suspended due to spam complaints.</p>
        </div>
    </div>

    <div class="row foot">
        <div class="col-xs-12" v-show="!showSuccess && hasResults">
            <div class="button btn btn-default btn-outline btn-block m-t-12 m-b-12" :class="{ 'disabled' : selectedEntities.length == 0 }" @click="share">Share with {{ selectedEntities.length }} users</div>
        </div>

        <div class="col-xs-12" v-show="showSuccess && hasResults">
            <div class="button btn btn-default btn-outline btn-block m-t-12 m-b-12" @click="ok">OK</div>
        </div>

        <div class="col-xs-12" v-show="!hasResults && !loading">
            <input type="text" placeholder="Email" v-model="newEmail">
            <input type="text" placeholder="Name" v-model="newName">
            <div class="button btn btn-primary btn-outline btn-block m-b-12" @click="createContact">
                <span class="iconify icon:zmdi:account-add"></span>
                Create new contact
            </div>
        </div>
    </div>

    <div class="move-to-root">
        <transition name="page-overlay">
                <div class="page-overlay filters" v-if="showFilters">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="btn-close button button-center pull-left" @click="closeFilters()">
                                    <i class="iconify" data-icon="ic:outline-chevron-left" data-inline="false"></i>
                                </div>
                            </div>
                            <div class="col-xs-12 content">
                                <input type="text" class="search-filters" placeholder="Search for genres and countries" v-model="search">
                                <i class="iconify" data-icon="ic:sharp-search"></i>

                                <p class="title text-right">
                                    <span class="pull-left"><b>Genres</b> ({{ totalGenres }}/{{ this.filters.genres.length }})</span>
                                    <a @click="toggleFilterAll('genres', false)">select all</a>&nbsp;
                                    <a @click="toggleFilterAll('genres', true)">select none</a>
                                </p>
                                <ul class="list genres">
                                    <li v-for="(g,i) in filters.genres" class="button" @click="toggleFilter('genres', i)" :class="{'selected' : isSelectedFilter('genres', i) }">{{ g.name }}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="row m-t-12">
                            <div class="col-xs-12 content">
                                <p class="title text-right">
                                    <span class="pull-left"><b>Countries</b> ({{ totalCountries }}/{{ this.filters.countries.length }})</span>
                                    <a @click="toggleFilterAll('countries', false)">select all</a>&nbsp;
                                    <a @click="toggleFilterAll('countries', true)">select none</a>
                                </p>

                                <ul class="list countries">
                                    <li v-for="(cg,i) in filters.countries" class="button col-xs-4" @click="toggleFilter('countries', i)" :class="{'selected' : isSelectedFilter('countries', i) }">{{ cg.name }}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 text-center m-t-12">
                                <div class="btn btn-default btn-outline button btn-save" @click="closeFilters()">CONFIRM SELECTION</div>
                            </div>
                        </div>                      
                    </div>
                </div>
        </transition>
    </div>    
</div>
</template>

<script>
export default {
    components: {
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['song'],

    data() {
        return {
            loading: true,
            results: [],
            totalResults: 0,
            selectedEntities: [],
            filters: false,
            showFilters: false,
            showSuccess: false,
            search: '',
            newEmail: '',
            newName: '',
            shareLink: false,
            reqData:{
                id: 0,
                countries: [],
                genres: [],
                ignore_blocked_by: true,
                public_or_following_back: true,
                page: 1,
                name: "",
                only_contacts: false,
                types: ["Label", "Artist", "Dj", "Broadcasters", "Blog"],
                with_contacts: true
            }
        }
    },

    mounted() {
        var that = this;
        $(".move-to-root").appendTo(".page-content");

        // initialize stuff and arrays
        this.countryGroups = $.extend({}, App.countryGroups);
        this.filters = $.extend(true, {}, App.filters.raw);

        this.filters.countries.sort((a, b) => {
            var aName = a.name.toLowerCase();
            var bName = b.name.toLowerCase(); 
            return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
        });

        this.filters.genres.sort((a, b) => {
            var aName = a.name.toLowerCase();
            var bName = b.name.toLowerCase(); 
            return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
        });

        $.each(App.filters.raw.countries, (i,c) => { this.reqData.countries.push(c.name); })
        $.each(App.filters.raw.genres, (i,g) => { this.reqData.genres.push(g.name); })

        //vertical
        $(`#share-tab .content`).on('scroll', function() {
            if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 120) {
                if (that.fetchedAllUsers || that.loading) {
                    return;
                }

                that.loading = true;
                that.reqData.page++;

                $(this).animate({ scrollTop: $(this)[0].scrollHeight }, 250);
                that.getData(true);
            }
        })

        $(`#share-tab .head input`).on('keyup', function() {
            that.reqData.name = $(this).val();
        })

        if (App.platform == 'ios'){
            $(document).on('focusin', () => {
                var navInterval = setInterval( () => {
                    if ( $('body').scrollTop() ){
                        $('.page-content .message-panel .messages-list').css('height', $(window).height() - $('body').scrollTop() - 207);
                        this.scrollBottom();
                        clearInterval(navInterval);
                    }
                }, 10);
            });

            $(document).on('focusout', () => {
                $('.page-content .message-panel .messages-list').removeAttr('style');
                this.scrollBottom();
            });
        }

        this.getData();
        this.getShareLink();
        this.listenForEvents();
        $('main').animate({ scrollTop: $('main')[0].scrollHeight }, 1000);
    },

    methods: {
        getData(append = false, callback = false) {
            this.loading = true;
            if (!append){
                this.results = [];
                this.reqData.page = 1;
            }

            //prevent async loading when fast-searching
            this.reqData.id++;
            var reqID = this.reqData.id * 1;

            this.$http.post(this.searchEndpoint, this.reqData).then((success) => {
                //stop if not latest request
                if (reqID < this.reqData.id) return;

                $.each(success.data.data.data, (i,u) => {
                    this.results.push(u);
                })

                this.totalResults = success.data.data.total;
                this.loading = false;
            });
        },

        getShareLink(){
            this.$http.get(this.shareLinkEndpoint).then((success) => {
                var token = success.data.token;
                var fullUrl = `https://app.soundfeedapp.com/song/${this.song.id}?token=${token}`;
    
                this.$http.post("https://url.soundfeedapp.com/generate", {url: fullUrl}, { emulateJSON: true }).then((success) => {
                    this.shareLink = success.data;
                });                
            });
        },

        searchContacts(){
            this.reqData.name = $('input.search').val();
            this.getData();
        },

        share(){
            var shareEntities = $.extend([], this.selectedEntities);

            if (shareEntities.length == 0) return;
            this.loading = true;

            this.$http.post(this.checkNotInterestedReceiversEndpoint, { receivers: this.selectedEntities }).then((success) => {
                //remove entities that don't want share
                $.each(success.data.data.not_interested_receivers, (i,e) => {
                    shareEntities = $.grep(shareEntities, (u) => { return u.id != e.id; });
                })

                $.each(shareEntities, function(i, entity){
                    entity.is_contact = entity.is_contact ? true : false;
                });

                this.$http.post(this.suggestSongEndpoint, { entities: shareEntities }).then((success) => {
                    if (App.allowGtag) gtag('event', `share_song`, {
                        'event_category' : 'song',
                        'event_label' : `Share ${ this.isOwner ? 'own' : 'other user' } song`
                    });  

                    this.showSuccess = true;
                    this.loading = false;
                    this.selectedEntities = [];
                }); 
            });
        },

        ok(){
            setTimeout(() => {
                this.showSuccess = false;
            }, 250);
        },

        createContact(){
            if ( this.loading || !this.newName.length || !this.newEmail.length ) return;
            this.loading = true;

            var userData = {
                email: this.newEmail,
                name: this.newName,
                country_id: 1
            }

            if (App.allowGtag) gtag('event', `create_contact`, {
                'event_category' : 'song',
                'event_label' : `Create new contact in share page`
            }); 

            this.$http.post(App.restApi + '/api/user/' + App.user.id + '/generics/contact', userData).then((success) => {
                this.loading = false;
                this.newEmail = '';
                this.newName = '';
                this.getData();
            }).catch((error) => {
                this.loading = false;
                console.log( error.data );
            });            
        },

        shareMobile(){
            if (navigator.share) {
                navigator.share({
                    title: `${this.song.name} - ${this.song.artist}`,
                    text: `Check out this great song from ${this.song.uploader.name}`,
                    url: this.shareLink
                }).then(() => { alert('Successful share') })
                .catch((error) => { alert('Error sharing:'+ error.message) });
            }else{
                alert('Navigator share disabled for ' + this.shareLink)
            }
        },

        toggleSelect(user) {
            if (this.isSelected(user)){
                this.selectedEntities = $.grep(this.selectedEntities, (u) => { return u.id != user.id; });
            }else{
                this.selectedEntities.push(user);
            }
        },

        isSelected(user) {
            return $.grep(this.selectedEntities, (u) => { return u.id == user.id; }).length;
        },

        selectAll(){
            if (this.selectedAllUsers){
                $.each(this.results, (i, user) => {
                    this.selectedEntities = $.grep(this.selectedEntities, (u) => { return u.id != user.id; });
                });
            }else{
                $.each(this.results, (i, user) => {
                    if (!this.isSelected(user)){
                        this.selectedEntities.push(user);
                    }
                });
            }
        },

        profileImage(user) {
            return `background-image: url('${user.profile_image_direct_url}')`;
        },

        closeFilters(){
            setTimeout(() => {
                this.showFilters = false;
            }, 350);
        },

        toggleFilter(type, index){
            this.filters[type][index].status = this.filters[type][index].status ? 0 : 1;
        },

        toggleFilterAll(type, state){
            if (type == 'genres'){
                if(state){
                    $.each(this.filters[type], (i, li) => { setTimeout(() => { this.filters[type][i].status = 0; }, i * 5); });
                }else{
                    $.each(this.filters[type], (i, li) => { setTimeout(() => { this.filters[type][i].status = 1; }, i * 5); });
                }
            }

            if (type == 'countries'){
                if(state){
                    $.each(this.filters[type], (i, li) => { this.filters[type][i].status = 0; });
                }else{
                    $.each(this.filters[type], (i, li) => { this.filters[type][i].status = 1; });
                }
            }
        },

        isSelectedFilter(type, index){
            return this.filters[type][index].status;
        },        

        listenForEvents() {
            this.$root.$on('showShareSuccess', () => {
                this.active = 'success';
            });
            this.$root.$on('showShareHistory', () => {
                this.active = 'history';
            });
            this.$root.$on('showPersonalDatabaseReceivers', () => {
                this.active = 'receivers';
            });
            this.$root.$on('showAllReceivers', () => {
                this.active = 'receivers';
            });
        },
    },

    computed: {
        totalGenres(){
            return $.grep(this.filters.genres, function(g, i) { return g.status != 0 }).length;
        },

        totalCountries(){
            return $.grep(this.filters.countries, function(c, i) { return c.status != 0 }).length;
        },

        searchEndpoint(){
            return App.restApi + '/api/user/search';
        },

        fetchedAllUsers(){
            return this.totalResults == this.results.length;
        },

        hasResults(){
            return this.totalResults;
        },

        selectedAllUsers(){
            return $.grep(this.results, (u) => { return !this.isSelected(u); }).length ? false : true;
        },

        shareLinkEndpoint(){
            return App.restApi + '/api/token/song/' + this.song.id;
        },

        suggestSongEndpoint() {
            return App.restApi + '/api/song/' + this.song.id + '/suggestion';
        },

        checkNotInterestedReceiversEndpoint() {
            return App.restApi + '/api/song/' + this.song.id + '/suggestion/not-interested-receivers';
        },

        isOwner(){
            return this.song.uploader_id == App.user.id;
        },

        isAndroid(){
            return App.platform == 'android';
        }
    },

    watch: {
        showFilters(){
            this.search = '';
            
            if (this.showFilters == false){
                $('.page-content').addClass('hasFooter');

                this.reqData.countries = [];
                $.each(this.filters.countries, (i, c) => {
                    if ( c.status ) this.reqData.countries.push(c.name);
                })

                this.reqData.genres = [];
                $.each(this.filters.genres, (i, g) => {
                    if ( g.status ) this.reqData.genres.push(g.name);
                })

                this.getData();
            }else{
                $('.page-content').removeClass('hasFooter');
            }       
        },

        search(){
            var qString = this.search;
            $('.page-overlay.filters .list li').each((i,e) => {
                if ($(e).text().toLowerCase().indexOf( qString.toLowerCase() ) == -1 && qString.length){
                    $(e).hide();
                }else{
                   $(e).show();
                }
            })
        }
    }
}
</script>
